import * as tokens from '../../../../../tokens/color.light.generated.js';
export const systemColorLight = {
    color: {
        foreground: {
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_100_LIGHT,
                    200: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_200_LIGHT,
                    300: tokens.SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_300_LIGHT
                }
            },
            neutral: {
                300: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT
            }
        },
        surface: {
            interactive: {
                primary: {
                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_LIGHT
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map